import {createAsyncThunk} from '@reduxjs/toolkit'
import AxiosClient from '../AxiosClient'
import {ERP_BASE, OMS_BASE} from 'src/utils/constants'

export const getOmsCustomersAsync = createAsyncThunk(
  'omsCustomers/getOmsCustomersAsync',
  async function (
    params: {
      search?: string
      id?: number | string
      sort_by?: string
      order_by?: string
      type?: string
      page?: number
      limit?: number
      include?: string
    },
    toolkit
  ) {
    return await AxiosClient(
      'GET',
      `${OMS_BASE}/customers`,
      [],
      toolkit,
      {
        page: params.page ?? 1,
        limit: params.limit ?? 10,
        sort_by: params.sort_by ?? 'asc',
        order_by: params.order_by ?? 'id',
        type: params.type ?? 'customer',
        include: params.include ?? 'address',
        ...(params.search ? {search: params.search} : {}),
        ...(params.id ? {id: params.id} : {}),
      },
      toolkit.signal
    )
  }
)

export const getOmsCustomerDetailsAsync = createAsyncThunk(
  'omsCustomers/getOmsCustomerDetailsAsync',
  async function (
    payload: {
      id: number | string
      include?: string
    },
    toolkit
  ) {
    return await AxiosClient(
      'GET',
      `${OMS_BASE}/customers/${payload.id}`,
      [],
      toolkit,
      {include: payload.include ?? 'address,additional_data'},
      toolkit.signal
    )
  }
)

export const createOmsCustomerAsync = createAsyncThunk(
  'omsCustomers/createOmsCustomerAsync',
  async function (payload: any, toolkit) {
    return await AxiosClient('POST', `${OMS_BASE}/customers`, payload, toolkit, [])
  }
)

export const updateOmsCustomerAsync = createAsyncThunk(
  'omsCustomers/updateOmsCustomerAsync',
  async function (payload: {id: number | string; data: any}, toolkit) {
    return await AxiosClient('PUT', `${OMS_BASE}/customers/${payload.id}`, payload.data, toolkit, [])
  }
)
